/* eslint-disable */
// prettier-ignore

export const messages = {
  system_admin_sso_title: "Configuraciones de Single Sign-On (SSO)",
  system_admin_sso_add: "Agregar configuración de SSO",
  system_admin_sso_update: "Actualizar configuración de SSO",
  system_admin_sso_domain: "Dominio",
  system_admin_sso_type: "Tipo",
  system_admin_sso_provider: "Proveedor",
  system_admin_sso_oauth_config: "Configuración OAuth",
  system_admin_sso_created_successfully: "Configuración de SSO creada con éxito",
  system_admin_sso_updated_successfully: "Configuración de SSO actualizada con éxito",
  system_admin_sso_warning: "Un <u>dominio</u> solo puede tener <i><u><b>una</b></u></i> configuración SSO activa a la vez. Al activar una configuración, se <i><u><b>desactivará</b></u></i> la actualmente activa.",
  system_admin_sso_do_you_really_want_to_activate_the_sso_config: "¿Realmente desea activar la configuración de SSO?",
  system_admin_sso_do_you_really_want_to_deactivate_the_sso_config: "¿Realmente desea desactivar la configuración de SSO?",
  system_admin_sso_login_url: "URL de inicio de sesión",
  system_admin_sso_client_id: "ID del cliente",
  system_admin_sso_client_secret: "Secreto del cliente",
  system_admin_sso_auth_url: "URL de autorización",
  system_admin_sso_token_url: "URL del token",
  system_admin_sso_user_info_url: "URL de información del usuario",
  system_admin_sso_entity_id: "ID de entidad",
};
